/* eslint-disable import/prefer-default-export */
export var mobileBreak = function mobileBreak() {
  return (window.innerWidth || document.body.clientWidth) <= 666;
};